// extracted by mini-css-extract-plugin
export default {"exclusiveEventBanner":"ExclusiveEventBanner_exclusiveEventBanner__PcZkX","tag":"ExclusiveEventBanner_tag__i4oc+"};